import * as React from "react";
import { InfoWindowF } from "@react-google-maps/api";
import type { Stop } from "../../../types";
import { Icon, Badge, Heading } from "@ogt/ui";

type PoiType = "parking" | "ticketAgent" | "ticketMachine";

type PoiInfoWindowProps = {
  type: PoiType;
  poi: Stop & { label?: string; showIcon?: boolean };
  position: google.maps.LatLngLiteral;
  onClose?: () => void;
};

const TYPE_LABEL: Record<PoiType, string> = {
  parking: "Parkeringsplats",
  ticketAgent: "Försäljningsombud",
  ticketMachine: "Biljettautomat",
};

type IconName = React.ComponentProps<typeof Icon>["name"];
type BadgeVariant = React.ComponentProps<typeof Badge>["variant"];

const TYPE_ICON: Record<PoiType, IconName> = {
  parking: "p",
  ticketAgent: "vendor",
  ticketMachine: "Logomobile",
};

const TYPE_VARIANT: Record<PoiType, BadgeVariant> = {
  parking: "blue",
  ticketAgent: "red",
  ticketMachine: "grey",
};

export default function PoiInfoWindow({
  type,
  poi,
  position,
  onClose,
}: PoiInfoWindowProps) {
  const title = poi.name || TYPE_LABEL[type];

  return (
    <InfoWindowF
      position={position}
      onCloseClick={onClose}
      options={{
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(0, -50),
      }}
    >
      <div className="pt-0 pl-4 pr-6 pb-6 min-w-[200px] text-sm leading-snug bg-[var(--semantic-color-bg-primary)]">
        <div className="flex gap-2 mb-2 items-center">
          <Badge
            icons={[<Icon key="poi" name={TYPE_ICON[type]} />]}
            shape="default"
            state="default"
            variant={TYPE_VARIANT[type]}
          />
          <Heading
            as="h3"
            className="text-[var(--semantic-color-text-primary)] mb-0"
          >
            {title}
          </Heading>
        </div>

        <p className="mb-1 text-[var(--semantic-color-text-secondary)]">
          {TYPE_LABEL[type]}
        </p>

        {"label" in poi && poi.label && (
          <p className="mb-0 text-[var(--semantic-color-text-primary)]">
            {poi.label}
          </p>
        )}
      </div>
    </InfoWindowF>
  );
}
